// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-layout {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  grid-template-rows: repeat(4, minmax(0, 130px));
  gap: 1rem;
}

/* .scrollbar-gray {
  background-color: #231c42;
} */
/* CSS */
.scrollbar-design {
  height: 75%;
  width: 100%;
  overflow-y: scroll;
  padding: 0 8px; /* Adjust padding as needed */
}

.scrollbar-design::-webkit-scrollbar {
  width: 10px; /* Set width of the scrollbar */
}

.scrollbar-design::-webkit-scrollbar-track {
  background: #f1f1f1; /* Change the background color of the scrollbar track */
}

.scrollbar-design::-webkit-scrollbar-thumb {
  background: #9c9c9c; /* Change the color of the scrollbar thumb */
  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */
}


.scrollbar-container {
  height: 210px;
  width: 100%;
  overflow-y: scroll;
  padding: 0 8px; /* Adjust padding as needed */
}

.scrollbar-container::-webkit-scrollbar {
  width: 10px; /* Set width of the scrollbar */
}

.scrollbar-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* Change the background color of the scrollbar track */
}

.scrollbar-container::-webkit-scrollbar-thumb {
  background: #9c9c9c; /* Change the color of the scrollbar thumb */
  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */
}


.scrollbar-custom::-webkit-scrollbar {
  width: 10px; /* Set width of the scrollbar */
}

.scrollbar-custom::-webkit-scrollbar-track {
  background: #f1f1f1; /* Change the background color of the scrollbar track */
}

.scrollbar-custom::-webkit-scrollbar-thumb {
  background: #bcbcbc; /* Change the color of the scrollbar thumb */
  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/styles.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,SAAS;AACX;;AAEA;;GAEG;AACH,QAAQ;AACR;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,mBAAmB,EAAE,4CAA4C;EACjE,kBAAkB,EAAE,uDAAuD;AAC7E;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,mBAAmB,EAAE,4CAA4C;EACjE,kBAAkB,EAAE,uDAAuD;AAC7E;;;AAGA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,mBAAmB,EAAE,4CAA4C;EACjE,kBAAkB,EAAE,uDAAuD;AAC7E","sourcesContent":[".dashboard-layout {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  grid-template-rows: repeat(4, minmax(0, 130px));\n  gap: 1rem;\n}\n\n/* .scrollbar-gray {\n  background-color: #231c42;\n} */\n/* CSS */\n.scrollbar-design {\n  height: 75%;\n  width: 100%;\n  overflow-y: scroll;\n  padding: 0 8px; /* Adjust padding as needed */\n}\n\n.scrollbar-design::-webkit-scrollbar {\n  width: 10px; /* Set width of the scrollbar */\n}\n\n.scrollbar-design::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Change the background color of the scrollbar track */\n}\n\n.scrollbar-design::-webkit-scrollbar-thumb {\n  background: #9c9c9c; /* Change the color of the scrollbar thumb */\n  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */\n}\n\n\n.scrollbar-container {\n  height: 210px;\n  width: 100%;\n  overflow-y: scroll;\n  padding: 0 8px; /* Adjust padding as needed */\n}\n\n.scrollbar-container::-webkit-scrollbar {\n  width: 10px; /* Set width of the scrollbar */\n}\n\n.scrollbar-container::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Change the background color of the scrollbar track */\n}\n\n.scrollbar-container::-webkit-scrollbar-thumb {\n  background: #9c9c9c; /* Change the color of the scrollbar thumb */\n  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */\n}\n\n\n.scrollbar-custom::-webkit-scrollbar {\n  width: 10px; /* Set width of the scrollbar */\n}\n\n.scrollbar-custom::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Change the background color of the scrollbar track */\n}\n\n.scrollbar-custom::-webkit-scrollbar-thumb {\n  background: #bcbcbc; /* Change the color of the scrollbar thumb */\n  border-radius: 2px; /* Optional: Add border-radius to the scrollbar thumb */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
